import {
  LocalizationLanguage,
  QuestionConfigAnswerOptionTranslationDto,
  QuestionConfigDetailDto,
  QuestionConfigTranslationDto,
} from "@green0meter/api-client";

export const emptyAnswerOptionTranslations: QuestionConfigAnswerOptionTranslationDto[] =
  Object.keys(LocalizationLanguage)
    .filter((v) => Number.isNaN(Number(v)))
    .map((language) => ({
      id: "",
      name: "",
      description: "",
      language: LocalizationLanguage[language as keyof typeof LocalizationLanguage],
    }));

export const emptyQuestionConfigTranslations: QuestionConfigTranslationDto[] =
  Object.keys(LocalizationLanguage)
    .filter((v) => Number.isNaN(Number(v)))
    .map((language) => ({
      id: "",
      name: "",
      description: "",
      language: LocalizationLanguage[language as keyof typeof LocalizationLanguage],
    }));

export const LanguageOptions = Object.values(LocalizationLanguage).filter(
  (value) => typeof value === "number",
) as LocalizationLanguage[];

export const newQuestionConfig: QuestionConfigDetailDto = {
  id: "",
  code: "",
  dataType: 2,
  componentType: 0,
  translations: LanguageOptions.map((language) => ({
    id: "",
    name: "",
    language,
  })),
  answerOptions: [],
  childQuestions: [],
};
